
import React from 'react';
import { Loader2 } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

interface LoadingStateProps {
  step?: number;
  message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ 
  step = 0, 
  message = "Carregando análise..." 
}) => {
  const progressValue = step > 0 ? Math.min(100, (step / 3) * 100) : 50;
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center px-6 max-w-md">
        <Loader2 size={40} className="animate-spin mx-auto mb-4 text-blue-dark" />
        <h2 className="text-xl font-semibold mb-2">Carregando análise</h2>
        <p className="text-gray-500 mb-4">{message || "Aguarde enquanto preparamos seu relatório..."}</p>
        
        {step > 0 && (
          <div className="w-full">
            <Progress value={progressValue} className="h-2 mb-2" />
            <p className="text-xs text-gray-400">
              Etapa {step} de 3
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingState;
